import { render, staticRenderFns } from "./observer.vue?vue&type=template&id=0e075abd&"
import script from "./observer.vue?vue&type=script&lang=ts&"
export * from "./observer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports